module.exports = __webpack_public_path__ + "static/img/banner.b00dcce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/travel/banner.jpg
// module id = cZk4
// module chunks = 1